<template>
  <div class="tvl-chart">
    <div
      :class="['tvl-bar mx-2', item.type]"
      :style="{ height: item.height }"
      v-for="item in allTvlItems"
      :key="item.name"
    >
      <div class="tvl-text pl-4 text-6 font-weight-medium">
        {{ item.text }} <span class="ml-1">${{ item.tvl }}M</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
export default {
  computed: {
    ...mapGetters({
      stakeStats: "productStats/stakeStats",
      vaultsStats: "productStats/vaultsStats",
      getVaultByTypeAndToken: "projectConfig/getVaultByTypeAndToken",
      ethereumStakingProjects: "projectConfig/ethereumStakingProjects",
      tendermintStakingProjects: "projectConfig/tendermintStakingProjects",
      solanaStakingProjects: "projectConfig/solanaStakingProjects",
      getTokenPrice: "appConfig/getTokenPriceInUsd",
    }),
    allTvlItems() {
      if (!this.vaultsStats.result || !this.stakeStats.result) return [];
      let items = [];
      this.vaultsStats.result.forEach(statItem => {
        const vault = this.getVaultByTypeAndToken({
          type: statItem.vaultType,
          token: statItem.token,
        });
        if (!vault) return;
        items.push({
          type: "vaults",
          text: vault.identity,
          tvl: new BN(statItem.expectedReturn)
            .multipliedBy(this.getTokenPrice(vault.coin))
            .toFixed(2, BN.ROUND_UP),
        });
      });
      [
        ...this.ethereumStakingProjects,
        ...this.tendermintStakingProjects,
        ...this.solanaStakingProjects,
      ].forEach(project => {
        const stakeItem = this.stakeStats.result.find(
          ss => ss.tokenName === project.staking.token
        );
        if (!stakeItem) return;
        items.push({
          type: "stake",
          text: project.text,
          tvl: new BN(Number(stakeItem.tokens) || 0)
            .multipliedBy(this.getTokenPrice(stakeItem.tokenName) || 0)
            .toFixed(2, BN.ROUND_UP),
        });
      });

      const highest = BN.max(...items.map(item => item.tvl));
      items = items
        .map(item => {
          item.height = (item.tvl / highest).toFixed(4) * 100 + "%";
          item.tvl = new BN(item.tvl).dividedBy(1e6).toFixed(2, BN.ROUND_UP);
          return item;
        })
        .filter(item => new BN(item.tvl).gte(0.01));
      return items;
    },
  },
};
</script>

<style lang="scss">
.tvl-chart {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 720px;
  width: 100%;
  z-index: 1;
  .tvl-bar {
    width: 24px;
    border-radius: 60px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    &.vaults {
      background: linear-gradient(rgba(138, 227, 182, 0.05) 0%, #8ae3b6 99%);
    }
    &.stake {
      background: linear-gradient(rgba(159, 170, 254, 0.05) 0%, #9faafe 99%);
    }
    .tvl-text {
      transform: rotate(-90deg);
      white-space: pre;
    }
  }
}
</style>
